"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderSectionItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const header_section_item_style_1 = __importDefault(require("./header.section.item.style"));
class HeaderSectionItem extends react_1.Component {
    render() {
        const { children, classes } = this.props;
        return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "data-cy": "atomic-header-section-item" }, { children: children }), void 0));
    }
}
exports.HeaderSectionItem = HeaderSectionItem;
HeaderSectionItem.propTypes = {
    children: prop_types_1.default.node.isRequired,
    classes: prop_types_1.default.object.isRequired
};
exports.default = react_jss_1.default(header_section_item_style_1.default)(HeaderSectionItem);
//# sourceMappingURL=header.section.item.js.map